<template>
    <table-template ref="renewal-car-record-table-template" actionUrl="/dbtCard/findRenewalCardRecord.action" :queryParams="queryParams">
        <template slot="search">
            <el-select v-model="queryParams.role" @change="$refs['renewal-car-record-table-template'].search()" clearable  placeholder="请选择">
                <el-option label="普通会员" :value="1"></el-option>
                <el-option label="经纪人" :value="2"></el-option>
                <el-option label="合伙人" :value="3"></el-option>
            </el-select>

            <el-select style="margin-left: 10px;" v-model="queryParams.payStatus" @change="$refs['renewal-car-record-table-template'].search()" clearable  placeholder="请选择">
                <el-option label="待支付" :value="1"></el-option>
                <el-option label="支付成功" :value="2"></el-option>
                <el-option label="支付失败" :value="3"></el-option>
                <el-option label="支付关闭" :value="4"></el-option>
                <el-option label="转入退款" :value="5"></el-option>
                <el-option label="取消支付" :value="6"></el-option>
                <el-option label="支付中" :value="7"></el-option>
            </el-select>

            <el-date-picker
                    clearable
                    style="margin-left: 10px;"
                    v-model="createTimeSearch"
                    @change="onCreateTimeChanged"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="充值筛选开始时间"
                    end-placeholder="充值筛选结束时间">
            </el-date-picker>

            <el-input style="margin-left: 10px;width: 200px;" v-model="queryParams.keyword" placeholder="昵称/手机号"></el-input>
            <el-button style="margin-left: 10px;" type="primary" @click="$refs['renewal-car-record-table-template'].search()">搜索</el-button>

        </template>
        <template slot="item">
            <el-table-column
                    prop="nickname"
                    label="昵称">
            </el-table-column>

            <el-table-column
                    prop="phone"
                    label="手机号">
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="角色">
                <template scope="scope">
                    {{scope.row.role | roleFilter}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="cardCount"
                    label="充值次数">
            </el-table-column>
            <el-table-column
                    label="支付金额">
                <template scope="scope">
                    <span v-if="scope.row.price">{{scope.row.price}} 元</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="支付状态">
                <template scope="scope">
                    <span  v-bind:style="{color: getPayStatusColor(scope.row.payStatus)}">{{scope.row.payStatus | payStatusFilter}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="充值时间">
                <template scope="scope">
                    {{scope.row.createTime | dateTimeFormat}}
                </template>
            </el-table-column>
        </template>
    </table-template>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
export default {
  name: 'opening-card-record',
  data () {
    return {
      createTimeSearch: null,
      queryParams: {}
    }
  },
  components: { TableTemplate },
  filters: {
    roleFilter (value) {
      let filter_value = '暂无'
      switch (value) {
        case 1:// 普通会员
          filter_value = '普通会员'
          break
        case 2:// 经纪人
          filter_value = '经纪人'
          break
        case 3:// 合伙人
          filter_value = '合伙人'
          break
      }
      return filter_value
    },
    payStatusFilter (value) {
      // 1-待支付；2-支付成功;3-支付失败;4-支付关闭;5-转入退款;6-取消支付;7-支付中
      let filter_value = '手动充值'
      switch (value) {
        case 1:// 待支付
          filter_value = '待支付'
          break
        case 2:// 支付成功
          filter_value = '支付成功'
          break
        case 3:// 支付失败
          filter_value = '支付失败'
          break
        case 4:// 支付关闭
          filter_value = '支付关闭'
          break
        case 5:// 转入退款
          filter_value = '转入退款'
          break
        case 6:// 取消支付
          filter_value = '取消支付'
          break
        case 7:// 取消支付
          filter_value = '支付中'
          break
      }
      return filter_value
    }
  },
  methods: {
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.createTimeSearchStart = null
        this.queryParams.createTimeSearchEnd = null
        this.$refs['renewal-car-record-table-template'].search()
        return
      }
      this.queryParams.createTimeSearchStart = datetime[0].getTime()
      this.queryParams.createTimeSearchEnd = datetime[1].getTime()
      this.$refs['renewal-car-record-table-template'].search()
    },
    getPayStatusColor (status) {
      let color = '#409EFF'
      switch (status) {
        case 1:// 待支付
          color = '#E6A23C'
          break
        case 2:// 支付成功
          color = '#67C23A'
          break
        case 3:// 支付失败
          color = '#F56C6C'
          break
        case 4:// 支付关闭
          color = '#909399'
          break
        case 5:// 转入退款
          color = '#909399'
          break
        case 6:// 取消支付
          color = '#909399'
          break
      }

      return color
    }
  }
}
</script>
